import {DateTime} from "luxon";
import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {ProjectTypeDTO} from "../domain/dtos/project-type.dto";
import {ProjectType} from "../domain/entities/project-type.entity";
import {AbstractDtoToEntityTransformer} from "./abstract-dto-to-entity.transformer";

@injectable()
@transformer({
    source: `dto`,
    target: ProjectType
})
export class DtoToProjectTypeTransformer extends AbstractDtoToEntityTransformer<ProjectTypeDTO, ProjectType> {

    public toEntity(dto: ProjectTypeDTO): Promise<ProjectType> {
        const entity = new ProjectType();

        Object.assign(entity, {
            key: dto.key,
            title: dto.title,
            projects: [],
            deletedAt: !!dto.deletedAt ? DateTime.fromSQL(dto.deletedAt) : null,
        });

        return Promise.resolve(entity);
    }
}